export default __webpack_public_path__ + "static/media/rb.ce72d38c.png";